// extracted by mini-css-extract-plugin
export var center = "_3o-2";
export var clickableRow = "_3o-5";
export var expandedRow = "_3o-7";
export var hoverable = "_3o-4";
export var left = "_3o-1";
export var right = "_3o-3";
export var row = "_3o-0";
export var selectedRow = "_3o-6";